'use client';

import { usePathname } from 'next/navigation';
import Link from 'next/link';
import clsx from 'clsx';

import { FullDarkLogo } from '@components/common/logo';
import { Routes } from '@lib/routes';

export function FooterLogo() {
  const pathname = usePathname();

  const handleClick = () => {
    if (pathname !== Routes.root) return;

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const inRoot = pathname === Routes.root;
  const Wrapper = inRoot ? 'div' : Link;

  return (
    <Wrapper
      href={Routes.root}
      onClick={handleClick}
      className={clsx(
        'col-span-full lg:col-span-1',
        inRoot && 'cursor-pointer',
      )}
    >
      <FullDarkLogo width={176} />
    </Wrapper>
  );
}
